import StartScreenText from './startScreenText';
import { useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useEffect } from 'react';
import { StepsContext } from '../context/StepsContext';
import { ModalPatient } from '@iq-solutions/nida-shared';
import { ModalClinician } from '@iq-solutions/nida-shared';
import { useNavigate } from 'react-router-dom';

interface Start {
  id: number;
  url: string;
}

const startScreen = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  const [start, setStart] = useState<Start>();
  const [show, setModalShow] = useState(false);
  const [userPatient, setPatient] = useState(false);
  const handleShow = (patient: boolean): void => {
    setModalShow(true);
    setPatient(patient);
    qContext.userType = patient ? 'patient' : 'clinician';
  };
  const handleHide = (): void => {
    setModalShow(false);
  };

  const navigate = useNavigate();

  const handleStart = (): void => {
    navigate(`/bstad/question/${start?.id}/${start?.url}`);
  };

  qContext.started = true;
  qContext.steps?.setCurrentIndex(0);
  qContext.currentStep = qContext.steps?.stepsArray[qContext.steps.currentIndexValue];
  qContext.answers = {};
  qContext.skippedSteps = [];
  qContext.completedSteps = [];
  qContext.total = qContext.steps?.stepsArray.length!;

  useEffect(() => {
    setStart({
      url: qContext.currentStep?.questionList[0].url!,
      id: qContext.currentStep?.questionList[0].id!,
    });
  }, [qContext]);

  return (
    <div className="introduction">
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>{userPatient ? 'Patient' : 'Clinician'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{userPatient ? <ModalPatient /> : <ModalClinician />}</Modal.Body>
        <Modal.Footer>
          <Button
            as="button"
            variant="primary"
            href={`/bstad/question/${start?.id}/${start?.url}`}
            onClick={handleStart}
            size="sm"
          >
            Start
          </Button>
          <Button variant="danger" size="sm" onClick={handleHide}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <StartScreenText />

        <div className="role-button-wrapper">
          <Button variant="link" as="button" type="button" onClick={() => handleShow(true)}>
            I am the patient
          </Button>
          <Button variant="link" as="button" type="button" onClick={() => handleShow(false)}>
            I am the clinician
          </Button>
        </div>
      </div>
    </div>
  );
};
export default startScreen;
